/**
 * Front-end behavior for Hero: Main (scoped to block instances).
 */
export class HeroMainFront {
	/**
	 * @param {ParentNode} root
	 */
	constructor( root = document ) {
		this.root = root;
	}

	init() {
		this.root.querySelectorAll( '[data-block="hero-main"]' ).forEach( ( el ) => {
			el.classList.add( 'hero-main-enhanced' );
			this.initVideoLightbox( el );
		} );
	}

	/**
	 * @param {HTMLElement} hero
	 */
	initVideoLightbox( hero ) {
		const dialog = hero.querySelector( '[data-hero-video-lightbox-dialog]' );
		const media = hero.querySelector( '[data-hero-video-lightbox-media]' );
		const triggers = hero.querySelectorAll( '[data-hero-video-lightbox]' );
		const closeBtn = hero.querySelector( '[data-hero-video-lightbox-close]' );

		if ( ! dialog || ! media || ! triggers.length ) {
			return;
		}

		triggers.forEach( ( button ) => {
			button.addEventListener( 'click', ( event ) => {
				event.preventDefault();
				this.openVideoLightbox( dialog, media, button );
			} );
		} );

		closeBtn?.addEventListener( 'click', () => {
			dialog.close();
		} );

		dialog.addEventListener( 'click', ( event ) => {
			if ( event.target === dialog ) {
				dialog.close();
			}
		} );

		dialog.addEventListener( 'close', () => {
			this.clearVideoLightbox( media );
		} );
	}

	/**
	 * @param {HTMLDialogElement} dialog
	 * @param {HTMLElement} media
	 * @param {HTMLElement} trigger
	 */
	openVideoLightbox( dialog, media, trigger ) {
		this.clearVideoLightbox( media );

		const type = trigger.dataset.videoType || 'file';

		if ( type === 'youtube' || type === 'vimeo' ) {
			const src =
				trigger.dataset.embedAutoplaySrc || trigger.dataset.embedSrc;

			if ( ! src ) {
				return;
			}

			const iframe = document.createElement( 'iframe' );
			iframe.src = src;
			iframe.title = 'Video';
			iframe.setAttribute(
				'allow',
				'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share'
			);
			iframe.setAttribute( 'allowfullscreen', '' );
			iframe.setAttribute(
				'referrerpolicy',
				'strict-origin-when-cross-origin'
			);
			media.appendChild( iframe );
		} else {
			const src = trigger.dataset.videoSrc;

			if ( ! src ) {
				return;
			}

			const video = document.createElement( 'video' );
			video.controls = true;
			video.playsInline = true;
			video.autoplay = true;

			const source = document.createElement( 'source' );
			source.src = src;
			source.type = trigger.dataset.videoMime || 'video/mp4';
			video.appendChild( source );
			media.appendChild( video );

			video.play().catch( () => {} );
		}

		if ( typeof dialog.showModal === 'function' ) {
			dialog.showModal();
		} else {
			dialog.setAttribute( 'open', '' );
		}
	}

	/**
	 * @param {HTMLElement} media
	 */
	clearVideoLightbox( media ) {
		const video = media.querySelector( 'video' );

		if ( video ) {
			video.pause();
			video.removeAttribute( 'src' );
			video.load();
		}

		media.replaceChildren();
	}
}
